import { render, staticRenderFns } from "./IntegrationComponent.vue?vue&type=template&id=58c6a51f&"
import script from "./IntegrationComponent.vue?vue&type=script&lang=ts&"
export * from "./IntegrationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports